import { EmploymentType } from '@aibees/elephant/utils';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface GetTooltipTitleParams {
  isSelfEmployedOrFreelancer: boolean;
  employmentType: EmploymentType;
  hasOnlyCompanyName: boolean;
  isNoLongerEmployed: boolean;
  noPreviousCompanyDataAvailable: boolean;
  hasOnlyPreviousCompanyName: boolean;
  wasPreviouslySelfEmployedOrFreelancer: boolean;
  previousEmploymentType: EmploymentType;
}

export function getTooltipTitle({
  isSelfEmployedOrFreelancer,
  employmentType,
  hasOnlyCompanyName,
  isNoLongerEmployed,
  noPreviousCompanyDataAvailable,
  hasOnlyPreviousCompanyName,
  wasPreviouslySelfEmployedOrFreelancer,
  previousEmploymentType,
}: GetTooltipTitleParams): ReactNode {
  if (wasPreviouslySelfEmployedOrFreelancer && previousEmploymentType) {
    return (
      <Typography variant="body5" fontWeight={500} textAlign="center">
        This Person previously worked as a {previousEmploymentType}. Company
        pages and company features aren't available.
      </Typography>
    );
  }
  if (noPreviousCompanyDataAvailable) {
    return (
      <Typography variant="body5" fontWeight={500} textAlign="center">
        The company information for this person's previous employment is
        unknown; Company Pages and features aren't available.
      </Typography>
    );
  }
  if (hasOnlyPreviousCompanyName) {
    return (
      <Typography variant="body5" fontWeight={500} textAlign="center">
        This person is no longer employed here. Only the Company Name is
        available, and Company Pages and Features are not accessible.
      </Typography>
    );
  }
  if (isNoLongerEmployed) {
    return (
      <Typography variant="body5" fontWeight={500} textAlign="center">
        This person is no longer employed here.
      </Typography>
    );
  }
  if (isSelfEmployedOrFreelancer && employmentType) {
    return (
      <Typography variant="body5" fontWeight={500} textAlign="center">
        <Typography component="span" variant="body5" fontWeight={700}>
          {employmentType}
        </Typography>{' '}
        — company pages and company features aren't available.
      </Typography>
    );
  }
  if (hasOnlyCompanyName) {
    return (
      <>
        <Typography variant="body5" fontWeight={700} textAlign="center">
          Company Name is only available
        </Typography>
        <Typography variant="body5" fontWeight={500} textAlign="center">
          Company Pages & Features aren't available.
        </Typography>
      </>
    );
  }
  return (
    <>
      <Typography variant="body5" fontWeight={700} textAlign="center">
        Company Information is not available.
      </Typography>
      <Typography variant="body5" fontWeight={500} textAlign="center">
        Company Pages & Features aren't available.
      </Typography>
    </>
  );
}
